import React from 'react'
import TextField from '@material-ui/core/TextField'
import Button from 'components/Button/Button'
import { apiUPDATECLIENTATTRIBUTE } from 'constants/Api'

export default class ResetPassword extends React.Component {
    state = {
        password: "",
        confirmPassword: "",
        passwordError: "",
        confirmPasswordError:"",
        nextError:"",
        loading: false
    }
    validate = () => {
        const completeMessage = "Please complete this field"
        let passwordError = (this.state.password.trim() === "") ? completeMessage : null,
            confirmPasswordError = (this.state.confirmPassword.trim() === "") ? completeMessage : null

        if(confirmPasswordError === null)
            confirmPasswordError = (this.state.confirmPassword.trim() !== this.state.password.trim()) ? "The passwords you entered do not match" : null

        this.setState({
            passwordError,
            confirmPasswordError
        })
        return !passwordError && !confirmPasswordError

    }
    handleText(e: any) {
        const input = e.target
        this.setState({
            nextError: null,
            [input.name]: input.value,
            [`${input.name}Error`]: null
        })
    }
    submitNext() {
        if (this.validate()) {
            const { password } = this.state
            this.setState({ loading: true }, () => {
                apiUPDATECLIENTATTRIBUTE({ password: password }).then((response) => {
                    if (response.success) {
                        //TODO: Redirect to buyer web
                        this.setState({ loading: false })
                    } else {
                        this.setState({ nextError: response.message, loading: false })
                    }
                }).catch((e) => {
                    this.setState({ nextError: e.message, loading: false })
                })
            })
        }
    }
    render() {
        const { password, confirmPassword, passwordError, confirmPasswordError, loading, nextError} = this.state
        return (
            <div className="enter-email-container">
                <div className="header">Reset your password</div>
                <div className="sub-header">Enter your new password below</div>
                <div className="form">
                    <div className="form-header">Password</div>
                    <form noValidate autoComplete="off">
                        <TextField
                            name="password"
                            className="text-input"
                            label="New Password"
                            variant="outlined"
                            type="password"
                            value={password}
                            helperText={passwordError}
                            onChange={(e) => this.handleText(e)}
                        />
                        <TextField
                            name="confirmPassword"
                            className="text-input"
                            label="Confirm Password"
                            variant="outlined"
                            type="password"
                            value={confirmPassword}
                            helperText={confirmPasswordError}
                            onChange={(e) => this.handleText(e)}
                        />
                        <Button onClick={() => this.submitNext()} title="Sign up" loading={loading} disabled={password.length === 0 || confirmPassword.length === 0} />
                        <div className="MuiFormHelperText-root">
                            <span className="justify-content-center">{nextError}</span>
                        </div>
                    </form>
                </div>
            </div>
        )
    }
}